import React from 'react';

import CheckBox from 'elements/Inputs/CheckBox';
import RadioButton from 'elements/Inputs/RadioButton';
import Selector from 'elements/Inputs/Selector';
import Dropdown from 'elements/Inputs/Dropdown';
import FormField from 'elements/Inputs/FormField';
import InputField from 'elements/Inputs/InputField';
import PasswordInput from 'elements/Inputs/PasswordInput';
import PrefixInput from 'elements/Inputs/PrefixInput';
import CCInput from 'elements/Inputs/CCInput';
import CVVInput from 'elements/Inputs/CVVInput';
import CCDateInput from 'elements/Inputs/CCDateInput';
import { Row } from 'components/Form/Layout';

const iconSizeMap = {
  'extra-small': '15',
  'small': '15',
  'normal': '15',
  'medium': '20',
  'medium-large': '20',
  'large': '20',
  'extra-large': '40'
};

const autoCompleteItems = [
  { text: 'Portugal' },
  { text: 'Germany' },
  { text: 'Italy' },
  { text: 'France' },
  { text: 'Netherlands' },
  { text: 'France' },
  { text: 'England' },
  { text: 'Greece' }
];

/* eslint-disable react/prop-types */
export const StandardCheckBox = ({ label, darkBg }) => (
  <CheckBox label={label} darkBg={darkBg} />
);

export const RoundCheckBox = ({ table }) => (
  <CheckBox rounded table={table} />
);

export const RadioButtons = ({ darkBg }) => (
  <RadioButton label="Some option" darkBg={darkBg} />
);

export const SingleSelector = ({
  large = true,
  text = 'Input Text',
  icon = null,
  label = null,
  doubleLine = false,
  withBg = false
}) => (
  <Selector text={text} large={large} icon={icon} label={label} doubleLine={doubleLine} withBg={withBg} />
);

export const MultiSelector = ({
  large = true,
  text = 'Input Text',
  icon = null,
  label = null,
  doubleLine = false,
  withBg = false
}) => (
  <Selector multi text={text} large={large} icon={icon} label={label} doubleLine={doubleLine} withBg={withBg} />
);

export const SpecialCaseSelector = ({ large = true, bgImage = 'Visa', text = null }) => (
  <Selector large={large} text={text} multi bgImage={bgImage} />
);

export const DropDowns = ({ label = 'label', darkBg, size = 'xl' }) => (
  <Dropdown label={label} darkBg={darkBg} size={size} opts={['option1', 'option2', 'option3']} />
);

export const DropDownsSimplified = ({ label = 'label', darkBg, red, size = 'xl' }) => (
  <Dropdown label={label} simplified darkBg={darkBg} red={red} size={size} opts={['option1', 'option2', 'option3']} />
);

export const StandardInputText = ({
  size = 'extra-large',
  darkBg,
  prefixText,
  suffixText,
  customClasses,
  label,
  dropdownLabel,
  note,
  icon,
}) => (
  <div style={{maxWidth: '690px'}}>
    <FormField size={size} darkBg={darkBg}>
      <InputField
        label={label}
        dropdownLabel={dropdownLabel}
        prefixText={prefixText}
        suffixText={suffixText}
        customClasses={customClasses}
        note={note}
        validations={['required']}
        icon={icon}
      />
    </FormField>
  </div>
);

export const PasswordTextInput = () => (
  <div>
    <FormField>
      <PasswordInput
        placeholder="Determine Password"
        customClasses="withIcon"
        validations={['required', 'password']}
        label="password"
      />
    </FormField>
  </div>
);

export const PhoneNumberInput = ({ locked }) => (
  <div style={{maxWidth: '230px'}}>
    <label>Phone number</label>
    <FormField>
      <Row>
        <PrefixInput placeholder="351" locked={locked} />
        <InputField type="number" />
      </Row>
    </FormField>
  </div>
);

export const CardNumberInput = ({ ccInput, expireDate, cvv, label = 'Credit Card' }) => (
  <div>
    {
      ccInput &&
        <FormField>
          <CCInput validations={['credit-card']} label={label} />
        </FormField>
    }
    {
      expireDate &&
        <FormField>
          <CCDateInput label={label} />
        </FormField>
    }
    {
      cvv &&
        <FormField>
          <CVVInput validations={['required', 'cvv']} label={label} />
        </FormField>
    }
  </div>
);

export const SearchFieldInput = ({ size = 'extra-large', darkBg, label }) => (
  <div>
    <FormField size={size} darkBg={darkBg}>
      <InputField placeholder="Input Text" label={label} icon={{icon: 'search', type: iconSizeMap[size]}} customClasses="withIcon" />
    </FormField>
  </div>
);

export const SearchFieldWithPrefix = ({ size = 'normal', darkBg, prefixText }) => (
  <div>
    <FormField size={size} darkBg={darkBg}>
      <InputField placeholder="Input Text" prefixText={prefixText} />
    </FormField>
  </div>
);

export const SearchWithWordFinder = () => (
  <div>
    <FormField size="normal">
      <InputField placeholder="European countries" autoComplete={autoCompleteItems} />
    </FormField>
  </div>
);

export const SearchWithClearField = ({ darkBg, size = 'medium-large' }) => (
  <div>
    <FormField size={size} darkBg={darkBg}>
      <InputField placeholder="Input Text" clearable autoComplete={autoCompleteItems} actionIcon={{icon: 'clear-fill-16', type: 'other' }} />
    </FormField>
  </div>
);

/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/elements/Inputs/constants/inputsLayouts.js